import { Box } from '@mui/material';
import { useMemo } from 'react';
import { useLabelColors } from './config';

export const useColorOptions = () => {
  const colors = useLabelColors();

  return useMemo(
    () =>
      Object.values(colors).map((color, idx) => ({
        key: idx.toString(),
        label: (
          <Box
            sx={{
              width: 20,
              height: 20,
              borderRadius: '50%',
              bgcolor: color,
            }}
          />
        ),
        value: color,
      })),
    [colors]
  );
};
